import React, { Component } from "react";
import { actions } from 'react-redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Button } from "react-bootstrap";

import { SelectFieldFloatingLabel as Select, InputFieldFloatingLabel as InputField} from "../../../../common/custom-form/select-filter.component";
import DATEPICKER_OR from "../../../../common/custom-form/custom-date-picker.component";
import { ControlTextarea } from "../../../../common/custom-form/control-field.component";
import { DATA_TYPE, MAX_LENGTH } from "../../../../../constants/external-constants";
import { InputAutoSuggest } from "../../../../common/custom-form/input-auto-suggest.component";
import { ConfirmationModal } from "../../../../common/modal/modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import { TRANSLATIONS } from "../../../../../utils/constant.utils";
import { disputeDetailActions } from "../../../../../store/external/invoice/dispute/dispute-details.reducer";
import { isObjectEqual } from "../../../../../utils/helpers.utils";
import { Loading } from "../../../../common/loading/index";

class DisputeFormView extends Component{
    constructor(props) {
        super(props);

        this.BilledCircuitIdAutoSuggest = React.createRef();
        this.MatchedCircuitIdAutoSuggest = React.createRef();
        this.InvoiceNumberAutoSuggest = React.createRef();
        this.ConfirmationModal = React.createRef();

        this.state = {
            saveModal: {
                title: "",
                messageBody: "",
                confirmAction: () => { }
            },
            saveNotif: {
                show: false,
                title: "",
                message: ""
            },
            isSaving: false
        };
    }

    async componentDidMount() {
        window.scrollTo(0, 0);
        const { disputeDetailsId, getDisputeDetailForm } = this.props;
        const formData = await getDisputeDetailForm(disputeDetailsId);

        if (formData) {
            const billedCircuitId = formData.BilledCircuit?.CircuitCode;
            const matchedCircuitId = billedCircuitId ? formData.BilledCircuit?.MatchedCircuitCode : formData.MatchedCircuit?.CircuitCode;

            this.BilledCircuitIdAutoSuggest.current.onChange(null, { newValue: billedCircuitId ?? '' });
            this.MatchedCircuitIdAutoSuggest.current.onChange(null, { newValue: matchedCircuitId ?? '' });
            this.InvoiceNumberAutoSuggest.current.onChange(null, { newValue: formData.Invoice?.InvoiceNumber ?? '' });
        }
        
    }

    toLocaleLanguage = (key, isCapitalize=true) => {
        const { locale } = this.props.translation;
        if (locale === null || locale === '')
            return TRANSLATIONS[TRANSLATIONS['defaultLocaleLanguage']][key];
        
        return isCapitalize ? TRANSLATIONS[locale][key].toUpperCase() : TRANSLATIONS[locale][key];
    }

    onChangeDisputeType = (model, value) => {
        const { selectDisputeType } = this.props;
        const { billedCircuitIdDisabled, matchedCircuitIdDisabled } = this.props.invoiceDisputeDetails;

        const result = selectDisputeType(model, value);

        if (result.billedCircuitIdDisabled !== billedCircuitIdDisabled && result.billedCircuitIdDisabled === true) {
            this.BilledCircuitIdAutoSuggest.current.onChange(null, { newValue: '' });
            this.MatchedCircuitIdAutoSuggest.current.onChange(null, { newValue: '' });
        }
        else if (result.matchedCircuitIdDisabled !== matchedCircuitIdDisabled && result.matchedCircuitIdDisabled === true) {
            this.MatchedCircuitIdAutoSuggest.current.onChange(null, { newValue: '' });
        }
    }

    onChangeInvoiceNumber = (value, propsName) => {
        this.props.selectInvoiceNumber(value, propsName)

        this.BilledCircuitIdAutoSuggest.current.onChange(null, { newValue: '' });
        this.MatchedCircuitIdAutoSuggest.current.onChange(null, { newValue: '' });
    }

    onChangeBilledCircuitID = (value, propsName) => {
        const billedCircuit = this.props.selectBilledCircuit(value, propsName);

        let billedMatchedCircuitCode = "";
        if (billedCircuit && billedCircuit.MatchedCircuitCode) {
            billedMatchedCircuitCode = billedCircuit.MatchedCircuitCode;
        }

        this.MatchedCircuitIdAutoSuggest.current.onChange(null, { newValue: billedMatchedCircuitCode });
    }

    disableSaveChanges = () => {
        const { invoiceDisputeDetailsForm, $form } = this.props;
        const { billedCircuitIdRequired, matchedCircuitIdRequired } = this.props.invoiceDisputeDetails;

        let disabled = !invoiceDisputeDetailsForm.disputeType
            || !invoiceDisputeDetailsForm.disputeStatus
            || !invoiceDisputeDetailsForm.invoiceNumber
            || !invoiceDisputeDetailsForm.potentialSavings
            || !invoiceDisputeDetailsForm.realizedSavings;

        if (billedCircuitIdRequired) {
            disabled = disabled || !invoiceDisputeDetailsForm.billedCircuitId;
        }

        if (matchedCircuitIdRequired) {
            disabled = disabled || !invoiceDisputeDetailsForm.matchedCircuitId;
        }

        const unchanged = isObjectEqual($form.loadedValue, invoiceDisputeDetailsForm);

        return disabled || unchanged;
    }

    handleSaveDispute = async (disputeId, validate = 1) => {
        const { saveDisputeForm, getDisputeDetailForm, invoiceDisputeDetailsForm } = this.props;

        this.setState({
            isSaving: true
        });

        const result = await saveDisputeForm(disputeId, validate);
        this.setState({
            isSaving: false
        });

        if (result.success) {
            if (result.isValid) {
                const confirmMessage = "Are you sure you want to save?";
                const modalTitle = this.toLocaleLanguage("call_save", false);
                const confirmAction = () => this.handleSaveDispute(invoiceDisputeDetailsForm.id, 0);
                this.toggleSaveModal(true, modalTitle, confirmMessage, confirmAction);
                return;
            }
            else {
                this.toggleSaveModal(false);
                this.toggleSaveNotif(true, this.toLocaleLanguage("success_modal_title", false), result.message);

                const data = result.data;
                getDisputeDetailForm(data.disputeId);
            }
        }
        else {
            this.toggleSaveModal(false);
            this.toggleSaveNotif(true, this.toLocaleLanguage("modal_error_title", false), result.message);
            return;
        }
    }

    toggleSaveModal = (isShow, title, message, confirmAction = () => { }) => {
        const { saveModal } = this.state;

        if (isShow) {
            this.ConfirmationModal.current.handleShow();
        }
        else {
            this.ConfirmationModal.current.handleClose();
        }

        this.setState({
            saveModal: {
                ...saveModal,
                title: title ?? "",
                messageBody: message ?? "",
                confirmAction: confirmAction
            },
        });
    }

    toggleSaveNotif = (isShow, title, message) => {
        const { saveNotif } = this.state;
        this.setState({
            saveNotif: {
                ...saveNotif,
                show: isShow,
                title: title ?? "",
                message: message ?? "",
            }
        });
    }

    render() {
        const { invoiceDisputeDetailsForm, invoiceDisputeDetails, isReadAndWrite } = this.props;

        return (
            <div className="dispute-container">
                {
                    invoiceDisputeDetails.fetchFormInProgress ?
                        <Loading />
                        :
                        <>
                            <div className="details-container dispute-container details-field-container mb-3">
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('dispute_id')}`}
                                    value={invoiceDisputeDetailsForm.disputeId ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.disputeId'
                                    maxLength={MAX_LENGTH.limit_100}
                                    disabled={true}
                                />

                                <Select
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('dispute_type')}`}
                                    options={invoiceDisputeDetails.disputeTypeList}
                                    value={invoiceDisputeDetailsForm.disputeType ?? ""}
                                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                    isError={false}
                                    fieldProp='invoiceDisputeDetailsForm.disputeType'
                                    onChangeAction={this.onChangeDisputeType}
                                    optionLabelKey={{
                                        Key: "Id",
                                        Value: "Name"
                                    }}
                                />

                                <Select
                                    className="form-select required"
                                    label={`${this.toLocaleLanguage('dispute_status')}`}
                                    options={invoiceDisputeDetails.disputeStatusList}
                                    value={invoiceDisputeDetailsForm.disputeStatus ?? ""}
                                    placeholder={this.toLocaleLanguage('select_placeholder', false)}
                                    isError={false}
                                    fieldProp='invoiceDisputeDetailsForm.disputeStatus'
                                    optionLabelKey={{
                                        Key: "Id",
                                        Value: "Name"
                                    }}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('created_by')}`}
                                    value={invoiceDisputeDetailsForm.createdBy ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.createdBy'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputAutoSuggest
                                    ref={this.InvoiceNumberAutoSuggest}
                                    label={`${this.toLocaleLanguage('invoice_number')}`}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder', false)}
                                    fieldProp="invoiceDisputeDetailsForm.invoiceNumberDisplay"
                                    value={invoiceDisputeDetailsForm.invoiceNumberDisplay ?? ""}
                                    propDisplay="InvoiceNumber"
                                    options={invoiceDisputeDetails.invoiceNumberList}
                                    onChangeAction={this.onChangeInvoiceNumber}
                                    searchAction={(searchVal, propsName) => this.props.getInvoiceNumber(searchVal, propsName)}
                                    required
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('account_number')}`}
                                    value={invoiceDisputeDetailsForm.accountNumber ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.accountNumber'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('vendor')}`}
                                    value={invoiceDisputeDetailsForm.vendor ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.vendor'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('country')}`}
                                    value={invoiceDisputeDetailsForm.country ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.country'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={""}
                                    disabled={true}
                                />
                                <DATEPICKER_OR                           
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('invoice_date')}`}
                                    startDate={invoiceDisputeDetailsForm.invoiceDate}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.invoiceDate", date)}
                                    isDisable={true}                                  
                                />

                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('invoice_actual_month')}`}
                                    startDate={invoiceDisputeDetailsForm.actualInvoiceMonth}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.actualInvoiceMonth", date)}
                                    isDisable={true}
                                    dateFormat="MMMM yyyy"
                                />
                            </div>

                            <div className="details-container details-field-container  mb-3 capital-uppercase">
                                <InputAutoSuggest
                                    ref={this.BilledCircuitIdAutoSuggest}
                                    label={`${this.toLocaleLanguage('billed_circuit_id')}`}
                                    placeholder={invoiceDisputeDetails.billedCircuitIdDisabled ? "" : this.toLocaleLanguage('enter_text_placeholder', false)}
                                    fieldProp="invoiceDisputeDetailsForm.billedCircuitIdDisplay"
                                    value={invoiceDisputeDetailsForm.billedCircuitIdDisplay ?? ""}
                                    propDisplay="CircuitCode"
                                    options={invoiceDisputeDetails.billedCircuitIdList}
                                    onChangeAction={this.onChangeBilledCircuitID}
                                    searchAction={(searchVal, propsName) => this.props.getBilledCircuitId(invoiceDisputeDetailsForm.invoiceNumber, searchVal, propsName)}
                                    required={invoiceDisputeDetails.billedCircuitIdRequired}
                                    disabled={invoiceDisputeDetails.billedCircuitIdDisabled}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('amount_charged')}`}
                                    value={invoiceDisputeDetailsForm.amountCharged ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.amountCharged'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={""}
                                    disabled={true}
                                />

                                <InputAutoSuggest
                                    ref={this.MatchedCircuitIdAutoSuggest}
                                    label={`${this.toLocaleLanguage('matched_circuit_id')}`}
                                    fieldProp="invoiceDisputeDetailsForm.matchedCircuitIdDisplay"
                                    value={invoiceDisputeDetailsForm.matchedCircuitIdDisplay ?? ""}
                                    propDisplay="CircuitCode"
                                    options={invoiceDisputeDetails.matchedCircuitIdList}
                                    onChangeAction={(value, propsName) => this.props.selectMatchedCircuit(value, propsName)}
                                    searchAction={(searchVal, propsName) => this.props.getMatchedCircuitId(invoiceDisputeDetailsForm.invoiceNumber, searchVal, propsName)}
                                    required={invoiceDisputeDetails.matchedCircuitIdRequired}
                                    disabled={invoiceDisputeDetails.matchedCircuitIdDisabled}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('mrc')}`}
                                    value={invoiceDisputeDetailsForm.mrc ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.mrc'
                                    maxLength={MAX_LENGTH.limit_100}
                                    placeholder={""}
                                    disabled={true}
                                />

                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={`${this.toLocaleLanguage('potential_savings')}`}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder', false)}
                                    value={invoiceDisputeDetailsForm.potentialSavings ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.potentialSavings'
                                    inputType={DATA_TYPE.decimal}
                                    maxLength={MAX_LENGTH.inputText}
                                    onChangeAction={(model, value) => { this.props.calculateAnnual(model, value) }}
                                />

                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('annual_potential_savings')}`}
                                    value={invoiceDisputeDetailsForm.annualPotentialSavings ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.annualPotentialSavings'
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={true}
                                />
                                <InputField
                                    className="form-control required"
                                    type="text"
                                    label={`${this.toLocaleLanguage('realized_savings')}`}
                                    placeholder={this.toLocaleLanguage('enter_text_placeholder', false)}
                                    value={invoiceDisputeDetailsForm.realizedSavings ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.realizedSavings'
                                    inputType={DATA_TYPE.decimal}
                                    maxLength={MAX_LENGTH.inputText}
                                    onChangeAction={(model, value) => { this.props.calculateAnnual(model, value) }}
                                />
                                <InputField
                                    className="form-control"
                                    type="text"
                                    label={`${this.toLocaleLanguage('annual_realized_savings')}`}
                                    value={invoiceDisputeDetailsForm.annualRealizedSavings ?? ""}
                                    fieldProp='invoiceDisputeDetailsForm.annualRealizedSavings'
                                    inputType={DATA_TYPE.decimal}
                                    maxLength={MAX_LENGTH.inputText}
                                    disabled={true}
                                />
                            </div>

                            <div className="details-container details-field-container  mb-3 capital-uppercase">
                                <DATEPICKER_OR                              
                                    label={`${this.toLocaleLanguage('date_created')}`}
                                    startDate={invoiceDisputeDetailsForm.dateCreated}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.dateCreated", date)}
                                    isDisable={true}
                                />

                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('submitted_to_vendor_date')}`}
                                    startDate={invoiceDisputeDetailsForm.submittedToVendorDate}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.submittedToVendorDate", date)}                  
                                />

                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('vendor_confirmation_date')}`}
                                    startDate={invoiceDisputeDetailsForm.vendorConfirmationDate}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.vendorConfirmationDate", date)}     
                                />

                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('expected_resolution_date')}`}
                                    startDate={invoiceDisputeDetailsForm.expectedResolutionDate}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.expectedResolutionDate", date)}                                    
                                />

                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('completed_date')}`}
                                    startDate={invoiceDisputeDetailsForm.completedDate}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.completedDate", date)}                                   
                                />

                                <DATEPICKER_OR
                                    dateOnly={true}
                                    label={`${this.toLocaleLanguage('credit_received_date')}`}
                                    startDate={invoiceDisputeDetailsForm.creditReceivedDate}
                                    selectedDate={(date) => this.props.FormChange("invoiceDisputeDetailsForm.creditReceivedDate", date)}                                   
                                />
                                <div className="grid-col-span-2 dispute-textarea">
                                    <ControlTextarea
                                        label={`${this.toLocaleLanguage('additional_information')}`}
                                        model='invoiceDisputeDetailsForm.additionalInformation'
                                        value={invoiceDisputeDetailsForm.additionalInformation ?? ""}
                                        placeholder={this.toLocaleLanguage('enter_text_placeholder', false)}
                                        maxLength={MAX_LENGTH.limit_255}
                                    />
                                </div>
                            </div>

                            <div className='dispute-save-btn save-btn-container'>
                                <ConfirmationModal
                                    ref={this.ConfirmationModal}
                                    title={this.state.saveModal.title}
                                    messageBody={this.state.saveModal.messageBody}
                                    confirmAction={this.state.saveModal.confirmAction}
                                    closeLabel={this.toLocaleLanguage("cancel_button", false)}
                                    confirmLabel={this.toLocaleLanguage("yes_button", false)}
                                    disabled={this.state.isSaving}
                                />

                                <NotificationModal
                                    show={this.state.saveNotif.show}
                                    title={this.state.saveNotif.title}
                                    message={this.state.saveNotif.message}
                                    handleModal={() => this.toggleSaveNotif(false)}
                                    customClass={'comment-notification-modal modal-text-bold notification-footer'}
                                />
                                {isReadAndWrite && 
                                <Button
                                    className='save-details-btn btn btn-primary'
                                        disabled={this.disableSaveChanges()}
                                    type="button"
                                    onClick={() => this.handleSaveDispute(invoiceDisputeDetailsForm.id)}
                                >
                                    Save Changes
                                </Button>
                                }
                            </div>
                        </>
                }
            </div>
        )
    }
}

export default connect(
    state => {
        const { invoiceDisputeDetails,
            translation,
            form: { forms: { invoiceDisputeDetailsForm: { $form } } }
        } = state;
        const { invoiceDisputeDetailsForm } = state.form;

        return {
            invoiceDisputeDetails,
            invoiceDisputeDetailsForm,
            translation,
            $form
        };
    },
    dispatch => ({
        ...bindActionCreators(
            Object.assign({}, disputeDetailActions),
            dispatch
        ),
        FormChange: (model, value) => {
            dispatch(actions.change(model, value))
        }
    })
)(DisputeFormView);